import LoginService from 'services/Login'
import StorageService from 'services/StorageService'

const _send = ({action, payload}) => {
    if(typeof window !== 'undefined' && window.newrelic){
        if(!action) action = 'userActivity';
        window.newrelic.addPageAction(action, payload);
    }
}

const NewRelicService = {
    sendPageAction: (options) => {
        try{
            const userData = LoginService.getUserData();
            if(!(options && (options.noAuth || (userData && userData.email) ) ) ) return false;

            if(!options.payload) options.payload = {};

            if(VERSION_ENV) options.payload.appVersion = VERSION_ENV;

            if(!options.noAuth) options.payload.email = userData.email;

            const orderFormId = StorageService.getItem('orderFormId');

            if(orderFormId) options.payload.orderFormId = orderFormId;

            _send(options);
        } catch (e){
            return false;
        }
    },
    sendPageActionNoAuth: (options) => {
        if(!options) return false;
        options.noAuth = true;

        NewRelicService.sendPageAction(options);
    },
    sendError: () => {
        
    }
}

export default NewRelicService;
